/*
 * cd-scenario-tabs — tab switcher for the "Choose your scenario" panel
 * on /pages/how-it-works.
 *
 * Every panel is rendered in the HTML (so crawlers see all five
 * scenarios) and CSS hides the inactive ones. Click or arrow-key on a
 * tab to swap which panel is visible. State is local to each section
 * instance so multiple instances on a page don't fight each other.
 */
(function () {
  if (window.__cdScenarioTabsInit) return;
  window.__cdScenarioTabsInit = true;

  function initInstance(root) {
    const tabs = Array.from(root.querySelectorAll('[data-cd-tab]'));
    const panels = Array.from(root.querySelectorAll('[data-cd-panel]'));
    if (tabs.length === 0 || panels.length === 0) return;

    const activate = (idx) => {
      tabs.forEach((t, i) => {
        const on = i === idx;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.setAttribute('tabindex', on ? '0' : '-1');
        t.toggleAttribute('data-active', on);
      });
      panels.forEach((p, i) => p.toggleAttribute('data-active', i === idx));
    };

    tabs.forEach((tab, i) => {
      tab.addEventListener('click', (e) => {
        e.preventDefault();
        activate(i);
        tab.focus();
      });
      tab.addEventListener('keydown', (e) => {
        let next = -1;
        if (e.key === 'ArrowRight') next = (i + 1) % tabs.length;
        else if (e.key === 'ArrowLeft') next = (i - 1 + tabs.length) % tabs.length;
        else if (e.key === 'Home') next = 0;
        else if (e.key === 'End') next = tabs.length - 1;
        if (next >= 0) {
          e.preventDefault();
          activate(next);
          tabs[next].focus();
        }
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-cd-scenarios]').forEach(initInstance);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
